import React from "react";
import { Phone, Mail, MapPin, Droplets } from "lucide-react";
import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-white">
      {/* Big CTA banner */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid md:grid-cols-2 gap-8 items-center">
          <h2 className="font-display text-4xl md:text-6xl font-black tracking-tighter leading-[0.95]">
            Let's get to <span className="text-sky-300">work.</span>
          </h2>
          <div className="md:text-right">
            <p className="text-slate-300 font-medium mb-4">
              Free quotes. Fast scheduling. Five-star results.
            </p>
            <a
              href={SITE.phoneHref}
              data-testid="footer-cta-phone"
              className="inline-flex items-center gap-3 px-6 h-14 rounded-2xl bg-white text-slate-900 font-display font-extrabold text-xl hover:bg-sky-300 transition-colors"
            >
              <Phone className="h-5 w-5" />
              {SITE.phone}
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-9 w-9 rounded-xl bg-blue-600 grid place-items-center">
              <Droplets className="h-5 w-5 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display font-extrabold text-white text-lg">
                {SITE.name}
              </div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-sky-300 font-bold -mt-0.5">
                Pressure Washing
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400 font-medium leading-relaxed max-w-md">
            Family-owned and Ohio-based. We deliver careful, honest pressure
            washing — and a finish you'll be proud of.
          </p>
        </div>

        <div>
          <h4 className="font-display font-extrabold text-white text-sm uppercase tracking-wider mb-4">
            Services
          </h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><a href="#services" className="hover:text-sky-300 font-medium">House Washing</a></li>
            <li><a href="#services" className="hover:text-sky-300 font-medium">Driveway Washing</a></li>
            <li><a href="#services" className="hover:text-sky-300 font-medium">Gutter Cleaning</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-extrabold text-white text-sm uppercase tracking-wider mb-4">
            Hours
          </h4>
          <ul className="space-y-2 text-sm text-slate-400">
            {SITE.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-3">
                <span className="font-semibold">{h.day}</span>
                <span className="font-medium text-slate-500">{h.time}</span>
              </li>
            ))}
          </ul>
          <ul className="space-y-2 text-sm text-slate-400 mt-5">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-sky-300" /><a href={SITE.phoneHref} className="font-semibold text-white hover:text-sky-300">{SITE.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-sky-300" /><a href={`mailto:${SITE.email}`} className="font-semibold text-white hover:text-sky-300 break-all">{SITE.email}</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-sky-300" /><span className="font-semibold text-white">All of Ohio</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500 font-medium">
          <p>© {new Date().getFullYear()} ClearView Pressure Washing. All rights reserved.</p>
          <p>Licensed & insured · Serving Ohio since 2010</p>
        </div>
      </div>
    </footer>
  );
};
